import { useState } from "react";

const Location = () => {
  const [activeTab, setActiveTab] = useState("america");

  const indiaLocations = [
    {
      name: "Harihar Ashram, Haridwar",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.322829039368!2d78.1333333151109!3d29.94111118191096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3909478934355be5%3A0x89099a529155ef!2sHarihar%20Aashram%2C%20Haridwar!5e0!3m2!1sen!2sin!4v1716382948123!5m2!1sen!2sin",
    },
    {
      name: "Prabhu Shri Vihar, Delhi",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56105.6983045755!2d77.08973990012497!3d28.491405613840737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1f3f9cc93035%3A0x878a8431db48516c!2sPrabhu%20Shri%20vihar!5e0!3m2!1sen!2sin!4v1761291563049!5m2!1sen!2sin",
    },
    {
      name: "Prabhu Prasang Ashram , Ambala",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110196.47075591366!2d76.79096826064635!3d30.332764372020637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fb78f4b714b77%3A0x30d6dafb5247f3ac!2sPrabhu%20Prem%20ashram!5e0!3m2!1sen!2sin!4v1761291826712!5m2!1sen!2sin",
    },
  ];

  const americaLocations = [
    {
      name: "New Jersey",
      attendee: "Sudhakar ",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194454.1938092895!2d-74.3353293569113!3d40.19132138753437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c0c27cdc395a3d%3A0x43469f27a9a1e489!2sNew%20Jersey%2C%20USA!5e0!3m2!1sen!2sin!4v1716478953115!5m2!1sen!2sin",
    },
    {
      name: "Atlanta",
      attendee: "Aditya Tulsian , Amit Bhuttan",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d212235.3334205035!2d-84.5606915494292!3d33.767919199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5045d6993098d%3A0x66fede2f39c07cf5!2sAtlanta%2C%20GA%2C%20USA!5e0!3m2!1sen!2sin!4v1716479000388!5m2!1sen!2sin",
    },
    {
      name: "Houston",
      attendee: "Dinesh Gupta ",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d442138.1239955885!2d-95.66542425!3d29.7804735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640b8b4488d8501%3A0xca0d02def365053b!2sHouston%2C%20TX%2C%20USA!5e0!3m2!1sen!2sin!4v1716383188055!5m2!1sen!2sin",
    },
    {
      name: "San Francisco ",
      attendee: "Gaurav Pathwardan",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201861.59203103815!2d-122.58323999249959!3d37.7576948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2sin!4v1716479038553!5m2!1sen!2sin",
    },
    {
      name: "Los Angeles",
      attendee: "Abhijit",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d424146.1020243728!2d-118.69192055!3d34.020730499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2sin!4v1716383163711!5m2!1sen!2sin",
    },
    {
      name: "Denver ",
      attendee: "Annie",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d392860.9296564018!2d-105.1386528733532!3d39.7643387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b80aa231f17cf%3A0x118ef4f8278a36d6!2sDenver%2C%20CO%2C%20USA!5e0!3m2!1sen!2sin!4v1716479071819!5m2!1sen!2sin",
    },
  ];

  return (
    <>
      <span id="location"></span>
      <section data-aos="fade-up" className="pb-12">
        <div className="container mx-auto px-4">
          <h1 className="text-center text-3xl font-serif text-[#5D4037] mb-8">
            Our Global Presence
          </h1>

          {/* Tabs */}
          <div className="flex justify-center mb-10">
            <div className="flex space-x-2 bg-white p-2 rounded-full shadow-md border border-[#B82A1E]/10">
              <button
                onClick={() => setActiveTab("america")}
                className={`px-6 py-2 text-sm font-medium rounded-full transition-colors duration-300 ${
                  activeTab === "america"
                    ? "bg-[#B82A1E] text-white shadow"
                    : "text-[#5D4037] hover:bg-[#B82A1E]/10"
                }`}
              >
                America
              </button>
              <button
                onClick={() => setActiveTab("india")}
                className={`px-6 py-2 text-sm font-medium rounded-full transition-colors duration-300 ${
                  activeTab === "india"
                    ? "bg-[#B82A1E] text-white shadow"
                    : "text-[#5D4037] hover:bg-[#B82A1E]/10"
                }`}
              >
                India
              </button>
            </div>
          </div>

          {/* Content */}
          <div>
            {activeTab === "india" && (
              <div className="flex flex-col md:flex-row gap-6 justify-center">
                {indiaLocations.map((loc, index) => (
                  <div key={index} className="flex-1 min-w-0">
                    <iframe
                      src={loc.mapUrl}
                      width="100%"
                      height="250"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      className="rounded-xl shadow-lg"
                    />

                    <p className="text-center mt-3 font-serif text-[#5D4037]">{loc.name}</p>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "america" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {americaLocations.map((loc, index) => (
                  <div key={index}>
                    <iframe
                      src={loc.mapUrl}
                      width="100%"
                      height="220"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      className="rounded-xl shadow-lg"
                    />
                    <div className="text-center mt-3">
                      <p className="font-serif text-[#5D4037]">{loc.name}</p>
                      <p className="text-sm text-[#5D4037]/70">Attendee: {loc.attendee}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Location;
